import { useGoodsSno } from '../hooks/useGoodsSno';
import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';

export const useGoodsReviewSummary = () => {
  const sno = useGoodsSno();
  return useQuery({
    queryKey: queryKey.goodsReviewSummary(sno),
    queryFn: () => goodsService.getGoodsReviewSummary(sno),
  });
};
